<template>
  <div
    @mouseenter="expandedMode = true"
    @mouseleave="expandedMode = false"
    class="md-layout md-alignment-center-center"
  >
    <div
      class="md-layout-item sinister-progress-container"
      :class="expandedMode ? 'expanded-mode' : ''"
    >
      <transition name="fade">
        <div v-show="expandedMode" class="expanded-sinister-progress">
          <div v-for="process in sorteredProcesses" class="md-layout-item text-center">
            <md-chip
              @mouseenter="hoveredProcess = process"
              class="text-center process-chip"
              :class="processProgressClass(process)"
            >
              <strong>{{ process.abbreviation }}</strong>

              <md-tooltip class="process-tooltip" md-direction="right" md-delay="750">
                <process-info :process="process" />
              </md-tooltip>
            </md-chip>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="progress-bar-container">
          <md-progress-bar
            class="sinister-progress"
            :class="currentProcessClass"
            md-mode="determinate"
            :md-value="progressPercentage"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import ProcessInfo from "@/pages/Macro/ProcessInfo";
import { mapState } from "vuex";

const DEFAULT_COLOR = "red";

export default {
  name: "SinisterProgressBar",

  props: {
    process: {
      type: Object,
      required: true,
      default: () => ({
        id: -1,
      }),
    },
    processesCatalog: {
      type: Array,
      required: false,
    },
  },

  components: {
    ProcessInfo,
  },

  computed: {
    ...mapState("catalogs", {
      localProcesses: (s) => s["macro/Carreteras/process"],
    }),
    processes() {
      const { processesCatalog, localProcesses } = this;
      return processesCatalog ? processesCatalog : localProcesses;
    },
    processPos() {
      const pid = this.process.id;
      const { sorteredProcesses } = this;
      const pos = sorteredProcesses.findIndex((p) => p.id == pid);
      if (pos >= 0) {
      }
      return pos >= 0 ? pos : 0;
    },
    progressPercentage() {
      const { processPos, sorteredProcesses } = this;
      return ((processPos + 1) * 100) / sorteredProcesses.length;
    },
    sorteredProcesses() {
      const processes = [...this.processes];
      return processes.sort(function (a, b) {
        return +a.number - +b.number;
      });
    },
    currentProcessClass() {
      const process = this.sorteredProcesses[this.processPos];

      return this.processClass(process);
    },
  },

  data() {
    return {
      expandedMode: false,
      hoveredProcess: null,
    };
  },

  methods: {
    processClass(process) {
      if (!process) {
        return "";
      }
      const colorKey = (process.color || DEFAULT_COLOR).replace(" ", "-");
      return `macro-${colorKey}`;
    },
    processProgressClass(process) {
      const macroClass = this.processClass(process);
      const { process: currentProcess } = this;
      const isCurrentProcess = currentProcess.id === process.id;
      const upperProcess = +process.number > +currentProcess.number;
      const hovered = this.hoveredProcess === process;
      return {
        [macroClass]: true,
        "current-process": isCurrentProcess,
        "inactive-process":
          process.id != currentProcess.id && !upperProcess && !hovered,
        "unreached-process": upperProcess && !hovered,
      };
    },
    displayExpandedMode(seconds = 5) {
      this.expandedMode = true;

      setTimeout(() => {
        this.expandedMode = false;
      }, seconds * 1000);
    },
  },

  watch: {
    process: {
      deep: true,
      immediate: true,
      handler() {
        this.displayExpandedMode(5);
      },
    },
  },
};
</script>

<style lang="css" scoped>
.sinister-progress-container {
  position: relative;
  height: 28px;
  margin-bottom: 5px;
}
.expanded-sinister-progress {
  position: absolute;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
}

.progress-bar-container {
  margin-top: 14px;
  align-items: center;
}

.md-chip.process-chip {
  font-size: 12px;
  /* padding: 0 11px; */
}

.md-chip.process-chip.current-process {
  font-size: 14px;
}

.inactive-process {
  filter: none;
  -webkit-filter: grayscale(70%);
  -moz-filter: grayscale(70%);
  -ms-filter: grayscale(70%);
  -o-filter: grayscale(70%);
  cursor: pointer;
}

.unreached-process {
  -webkit-filter: grayscale(40%);
  -moz-filter: grayscale(40%);
  -ms-filter: grayscale(40%);
  -o-filter: grayscale(40%);
  opacity: 0.4 !important;
}

.sinister-progress-container.expanded-mode .md-progress-bar {
  height: 10px;
}

.md-tooltip.process-tooltip {
  max-width: 350px;
  text-align: left;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/SinisterProgressBar.vue